import { PlanManagement } from "@/components/PlanManagement";
import { useNavigate } from "react-router-dom";

export const PlansPage = () => {
  const navigate = useNavigate();

  return <PlanManagement onBack={() => navigate("/")} />;
};
